import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { cn } from '@/lib/cn';

interface Props {
  source: string;
  className?: string;
  empty?: string;
}

/**
 * Render markdown with sensible prose styling that matches the app theme.
 * Uses GFM for tables, task lists, strikethrough.
 */
export function MarkdownView({ source, className, empty = 'No content.' }: Props) {
  const trimmed = source?.trim() ?? '';
  if (!trimmed) {
    return <p className={cn('text-sm italic text-muted-foreground', className)}>{empty}</p>;
  }
  return (
    <div
      className={cn(
        'prose prose-sm prose-invert max-w-none',
        'prose-headings:font-semibold prose-headings:tracking-tight',
        'prose-h1:text-xl prose-h2:text-lg prose-h3:text-base',
        'prose-p:my-2 prose-p:leading-relaxed',
        'prose-a:text-foreground prose-a:underline-offset-2',
        'prose-code:rounded prose-code:bg-muted prose-code:px-1 prose-code:py-0.5 prose-code:text-[0.85em] prose-code:before:hidden prose-code:after:hidden',
        'prose-pre:rounded-md prose-pre:bg-muted prose-pre:p-3 prose-pre:text-xs',
        'prose-ul:my-2 prose-ol:my-2 prose-li:my-0.5',
        'prose-blockquote:border-l-2 prose-blockquote:border-border prose-blockquote:text-muted-foreground',
        'prose-hr:border-border',
        'prose-table:text-xs prose-th:px-2 prose-td:px-2',
        className,
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{trimmed}</ReactMarkdown>
    </div>
  );
}
